var _path, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 20.00 0.00 L 20.00 20.00 L 0.00 20.00 L 0.00 0.00",
    fill: "#f3f3f3",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.8695651888847351, 0.8695651888847351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 8.70 0.00 L 8.70 8.70 L 0.00 8.70 L 0.00 0.00",
    fill: "#f35325",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.434782981872559, 0.8695651888847351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 8.70 0.00 L 8.70 8.70 L 0.00 8.70 L 0.00 0.00",
    fill: "#81bc06",
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.8695651888847351, 10.434782981872559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 8.70 0.00 L 8.70 8.70 L 0.00 8.70 L 0.00 0.00",
    fill: "#05a6f0",
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.434782981872559, 10.434782981872559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 0.00 L 8.70 0.00 L 8.70 8.70 L 0.00 8.70 L 0.00 0.00",
    fill: "#ffba08",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.8aef07d9bba12105e1ba4c30dd6d20d3.svg";
export { ForwardRef as ReactComponent };